// extracted by mini-css-extract-plugin
export default {"setting--inverted":"tj60QIQ","dark-theme":"WaCZgsR","social-media-links":"H6eKn9m","social-media-links__list":"TVi66I7","social-media-links__item":"Kpr1ueP"};